/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import {
  propTypesAltLanguage,
  propTypesIllustration,
  propTypesLink,
  propTypesTextHtml,
} from '../../../constants/Proptypes';

const propTypesContent = {
  label: PropTypes.shape(propTypesTextHtml),
  link: PropTypes.shape(propTypesLink),
  obfuscate: PropTypes.string,
};

const propTypesHeaderLink = {
  alternate_languages: PropTypes.shape(propTypesAltLanguage),
  data: PropTypes.shape({
    link_description: PropTypes.string,
    link_icon: PropTypes.string,
    link_label: PropTypes.shape(propTypesTextHtml),
    link_url: PropTypes.shape(propTypesLink),
  }),
  lang: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
};

export const propTypesHeaderSection = {
  alternate_languages: PropTypes.shape(propTypesAltLanguage),
  data: PropTypes.shape({
    links: PropTypes.arrayOf(PropTypes.shape(propTypesHeaderLink)),
    section_color: PropTypes.string,
    section_title: PropTypes.shape(propTypesTextHtml),
  }),
  lang: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
};

export const propTypesDropdown1 = {
  dropdown_1_description: PropTypes.string,
  dropdown_1_icon: PropTypes.string,
  dropdown_1_link_color: PropTypes.string,
  dropdown_1_link_name: PropTypes.string,
  dropdown_1_link_url: PropTypes.shape(propTypesLink),
};

export const propTypesDropdown2 = {
  dropdown_2_description: PropTypes.string,
  dropdown_2_icon: PropTypes.string,
  dropdown_2_link_color: PropTypes.string,
  dropdown_2_link_name: PropTypes.string,
  dropdown_2_link_url: PropTypes.shape(propTypesLink),
};

export const propTypesDropdown3 = {
  dropdown_3_description: PropTypes.string,
  dropdown_3_icon: PropTypes.string,
  dropdown_3_link_color: PropTypes.string,
  dropdown_3_link_name: PropTypes.string,
  dropdown_3_link_url: PropTypes.shape(propTypesLink),
};

export const propTypesDropdown4 = {
  dropdown_4_description: PropTypes.string,
  dropdown_4_icon: PropTypes.string,
  dropdown_4_link_color: PropTypes.string,
  dropdown_4_link_name: PropTypes.string,
  dropdown_4_link_url: PropTypes.shape(propTypesLink),
};

export const propTypesNavigation = {
  data: PropTypes.shape({
    blog_first_column_content: PropTypes.arrayOf(
      PropTypes.shape(propTypesContent)
    ),
    blog_first_column_name: PropTypes.shape(propTypesTextHtml),
    blog_fourth_column_content: PropTypes.arrayOf(
      PropTypes.shape(propTypesContent)
    ),
    blog_fourth_column_name: PropTypes.shape(propTypesTextHtml),
    blog_second_column_content: PropTypes.arrayOf(
      PropTypes.shape(propTypesContent)
    ),
    blog_second_column_name: PropTypes.shape(propTypesTextHtml),
    blog_third_column_content: PropTypes.arrayOf(
      PropTypes.shape(propTypesContent)
    ),
    blog_third_column_name: PropTypes.shape(propTypesTextHtml),
    description: PropTypes.shape(propTypesTextHtml),
    dropdown_1: PropTypes.shape(propTypesDropdown1),
    dropdown_1_label: PropTypes.string,
    dropdown_1_optiona_link: PropTypes.string,
    dropdown_1_optional_url: PropTypes.shape(propTypesLink),
    dropdown_2: PropTypes.shape(propTypesDropdown1),
    dropdown_2_label: PropTypes.string,
    dropdown_2_optiona_link: PropTypes.string,
    dropdown_2_optional_url: PropTypes.shape(propTypesLink),
    dropdown_3: PropTypes.shape(propTypesDropdown1),
    dropdown_3_label: PropTypes.string,
    dropdown_3_optiona_link: PropTypes.string,
    dropdown_3_optional_url: PropTypes.shape(propTypesLink),
    dropdown_4: PropTypes.shape(propTypesDropdown1),
    dropdown_4_label: PropTypes.string,
    dropdown_4_optiona_link: PropTypes.string,
    dropdown_4_optional_url: PropTypes.shape(propTypesLink),
    logo: PropTypes.shape(propTypesIllustration),
    logo_wooclap: PropTypes.shape(propTypesIllustration),
    menu_1: PropTypes.arrayOf(PropTypes.shape(propTypesHeaderSection)),
    menu_1_more_label: PropTypes.string,
    menu_1_more_link: PropTypes.shape(propTypesLink),
    menu_1_title: PropTypes.string,
    menu_2: PropTypes.arrayOf(PropTypes.shape(propTypesHeaderSection)),
    menu_2_more_label: PropTypes.string,
    menu_2_more_link: PropTypes.shape(propTypesLink),
    menu_2_title: PropTypes.string,
    menu_3: PropTypes.arrayOf(PropTypes.shape(propTypesHeaderSection)),
    menu_3_more_label: PropTypes.string,
    menu_3_more_link: PropTypes.shape(propTypesLink),
    menu_3_title: PropTypes.string,
    menu_4: PropTypes.arrayOf(PropTypes.shape(propTypesHeaderSection)),
    menu_4_more_label: PropTypes.string,
    menu_4_more_link: PropTypes.shape(propTypesLink),
    menu_4_title: PropTypes.string,
    signin_label: PropTypes.string,
    signin_url: PropTypes.shape(propTypesLink),
    signup_label: PropTypes.string,
    signup_url: PropTypes.shape(propTypesLink),
    social_networks: PropTypes.arrayOf(
      PropTypes.shape({
        social_link: PropTypes.shape(propTypesLink),
        social_name: PropTypes.string,
      })
    ),
    title_wooclap: PropTypes.shape(propTypesTextHtml),
    website_first_column_content: PropTypes.arrayOf(
      PropTypes.shape(propTypesContent)
    ),
    website_first_column_name: PropTypes.shape(propTypesTextHtml),
    website_fourth_column_content: PropTypes.arrayOf(
      PropTypes.shape(propTypesContent)
    ),
    website_fourth_column_name: PropTypes.shape(propTypesTextHtml),
    website_second_column_content: PropTypes.arrayOf(
      PropTypes.shape(propTypesContent)
    ),
    website_second_column_name: PropTypes.shape(propTypesTextHtml),
    website_third_column_content: PropTypes.arrayOf(
      PropTypes.shape(propTypesContent)
    ),
    website_third_column_name: PropTypes.shape(propTypesTextHtml),
  }),
  lang: PropTypes.string,
  type: PropTypes.string,
};
